// src/components/pages/Pessoa/helpers/buildPessoaReceitaData.js

import { onlyNumbers } from './pessoaDocUtils';

export function buildPessoaReceitaData(result, pessoaId = null) {
    const endereco = {
        uuid: '',
        pessoaId: pessoaId || '',
        cep: result?.cep || '',
        ufId: result?.ufId || '',
        municipioId: result?.municipioId || '',
        bairro: result?.bairro || '',
        logradouro: result?.logradouro || '',
        numero: result?.numero || '',
        complemento: result?.complemento || '',
        tipo: 'Comercial',
        principal: true,
        ativo: true,
        funcao: 'Adicionar',
    };

    const email = result?.email
        ? {
              uuid: '',
              pessoaId: pessoaId || '',
              email: result.email,
              tipo: 'Comercial',
              principal: false,
              ativo: true,
              funcao: 'Adicionar',
          }
        : null;

    const telefones = (result?.telefone || '')
        .split('/')
        .map((telefone) => onlyNumbers(telefone))
        .filter(Boolean)
        .map((numero) => ({
            uuid: '',
            pessoaId: pessoaId || '',
            numero,
            tipo: 'Trabalho',
            principal: false,
            zap: false,
            telegram: false,
            ativo: true,
            funcao: 'Adicionar',
        }));

    const juridica = {
        razaoSocial: result?.nome || '',
        nomeFantasia: result?.fantasia || '',
        abertura: result?.abertura || '',
        tipo: result?.tipo || 'MATRIZ',
        ramoAtividade: 'Industria',
    };

    return {
        endereco,
        email,
        telefones,
        juridica,
    };
}
